var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_9309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6124 18.4865C16.5694 18.4865 18.1559 16.9 18.1559 14.9429C18.1559 12.9859 16.5694 11.3994 14.6124 11.3994C12.6553 11.3994 11.0688 12.9859 11.0688 14.9429C11.0688 16.9 12.6553 18.4865 14.6124 18.4865Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13942 11.1858C0.13942 11.2284 0.0966797 11.3137 0.0966797 11.3565C0.0966797 11.7407 0.395516 12.0823 0.822459 12.0823H6.84228C7.14111 12.0823 7.35459 11.9115 7.48269 11.6553C8.72089 8.92293 11.4533 7.08706 14.5698 7.08706C18.8818 7.08706 22.3827 10.588 22.3827 14.9C22.3827 19.2121 18.8818 22.713 14.5698 22.713C11.4104 22.713 8.72078 20.8345 7.48269 18.1874C7.35459 17.8886 7.14111 17.7178 6.84216 17.7178H0.82269C0.438373 17.7178 0.0967955 18.0166 0.0967955 18.4437C0.0967955 18.4863 0.0967955 18.5716 0.139536 18.6144C1.80457 25.1038 7.65354 29.8855 14.6126 29.8855C22.8525 29.8855 29.5554 23.1825 29.5554 14.9428C29.5552 6.70286 22.8523 0 14.6125 0C7.65354 0 1.80445 4.78173 0.13942 11.1858Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_9309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.652,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCi);
export default __webpack_public_path__ + "static/media/circleCI.4d0e642d26a7e5bf6b418ea071291d42.svg";
export { ForwardRef as ReactComponent };